<div class="node">
  @if (node.cartaPorte) {
    <div>
      <div class="headline">
        <button
          mat-icon-button
          [ngClass]="{ hidden: !node.cartaPorte.tieneCartaPorteRelacionada }"
          (click)="toggleChildren(node)"
          >
          <mat-icon>{{
            node.isExpanded ? 'expand_more' : 'chevron_right'
          }}</mat-icon>
        </button>
        @if (node.cartaPorte) {
          <app-waybill-view
            [data]="node.cartaPorte"
          ></app-waybill-view>
        }
      </div>
      <mat-divider></mat-divider>
      @if (node.isExpanded && node.children) {
        <div>
          @for (child of node.children; track child) {
            <app-nested-view
              [node]="child"
            ></app-nested-view>
          }
        </div>
      }
    </div>
  }
</div>
